const teamActions = {
  // SAGA
  GET_TEAMS: 'GET_TEAMS',
  GET_TEAM: 'GET_TEAM',
  CREATE_OR_UPDATE_TEAM_WATCHER: 'CREATE_OR_UPDATE_TEAM_WATCHER',
  DELETE_TEAM_WATCHER: 'DELETE_TEAM_WATCHER',
  GET_TEAM_CUSTOMER_STATS: 'GET_TEAM_CUSTOMER_STATS',
  GET_TEAM_TICKET_STATS: 'GET_TEAM_TICKET_STATS',
  GET_TEAM_FEEDBACK_STATS: 'GET_TEAM_FEEDBACK_STATS',

  // REDUCER
  SET_TEAMS: 'SET_TEAMS',
  SET_TEAM: 'SET_TEAM',
  SET_TEAM_CUSTOMER_STATS: 'SET_TEAM_CUSTOMER_STATS',
  SET_TEAM_TICKET_STATS: 'SET_TEAM_TICKET_STATS',
  SET_TEAM_FEEDBACK_STATS: 'SET_TEAM_FEEDBACK_STATS',

  CREATE_TEAM: 'CREATE_TEAM',
  UPDATE_TEAM: 'UPDATE_TEAM',
  DELETE_TEAM: 'DELETE_TEAM',

  // ERROR
  TEAM_ERROR: 'TEAM_ERROR',
  RESET_TEAM_STATUS: 'RESET_TEAM_STATUS',

  // Saga functions
  getTeams: (query) => ({
    type: teamActions.GET_TEAMS,
    payload: query,
  }),

  getTeam: team => ({
    type: teamActions.GET_TEAM,
    payload: team,
  }),

  createOrUpdateTeamWatcher: team => {
    return {
      type: teamActions.CREATE_OR_UPDATE_TEAM_WATCHER,
      payload: team,
    };
  },

  deleteTeamWatcher: team => {
    return {
      type: teamActions.DELETE_TEAM_WATCHER,
      payload: team,
    };
  },

  // Saga functions for reports
  getTeamCustomerStats: (teamId) => ({
    type: teamActions.GET_TEAM_CUSTOMER_STATS,
    payload: teamId,
  }),

  getTeamTicketStats: (teamId) => ({
    type: teamActions.GET_TEAM_TICKET_STATS,
    payload: teamId,
  }),

  getTeamFeedbackStats: (teamId) => ({
    type: teamActions.GET_TEAM_FEEDBACK_STATS,
    payload: teamId,
  }),

  // Reducer functions
  setTeams: teams => ({
    type: teamActions.SET_TEAMS,
    payload: teams,
  }),

  setTeam: team => ({
    type: teamActions.SET_TEAM,
    payload: team,
  }),

  createTeam: team => {
    return {
      type: teamActions.CREATE_TEAM,
      payload: team,
    };
  },

  updateTeam: team => {
    return {
      type: teamActions.UPDATE_TEAM,
      payload: team,
    };
  },

  deleteTeam: team => {
    return {
      type: teamActions.DELETE_TEAM,
      payload: team,
    };
  },

  resetTeamStatus: () => {
    return {
      type: teamActions.RESET_TEAM_STATUS,
    };
  },

  // Reducer functions for reports
  setTeamCustomerStats: (stats) => ({
    type: teamActions.SET_TEAM_CUSTOMER_STATS,
    payload: stats,
  }),

  setTeamTicketStats: (stats) => ({
    type: teamActions.SET_TEAM_TICKET_STATS,
    payload: stats,
  }),

  setTeamFeedbackStats: (stats) => ({
    type: teamActions.SET_TEAM_FEEDBACK_STATS,
    payload: stats,
  }),
};

export default teamActions;
